import React, { useState } from 'react';
import './OurWork.css';

const OurWork = () => {
  const [selectedMedia, setSelectedMedia] = useState(null);

  const patientCases = [
    {
      id: 1,
      patientName: "Sana A.",
      age: 28,
      title: "Severe Crowding Correction",
      description: "Sana came to us with severely crowded teeth affecting her confidence. After 18 months of treatment with traditional braces, she achieved a perfect smile.",
      beforeImage: "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      afterVideo: "https://videos.pexels.com/video-files/6967714/6967714-uhd_2560_1440_25fps.mp4",
      treatment: "Traditional Metal Braces",
      duration: "18 months",
      testimonial: "I never thought I could have such a beautiful smile. Dr. Ahmed and the team were amazing!"
    }
  ];

  const successfulPatients = [
    {
      id: 1,
      name: "Amna R.",
      treatment: "Clear Aligners",
      image: "https://plus.unsplash.com/premium_photo-1689568158814-3b8e9c1a9618?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 2,
      name: "Hassan M.",
      treatment: "Metal Braces",
      image: "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 3,
      name: "Maryam K.",
      treatment: "Ceramic Braces",
      image: "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 4,
      name: "Ali S.",
      treatment: "Clear Aligners",
      image: "https://plus.unsplash.com/premium_photo-1661288449344-0f5fd8c1e88b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 5,
      name: "Nida F.",
      treatment: "Metal Braces",
      image: "https://images.unsplash.com/photo-1598256989809-394fa4f6cd26?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 6,
      name: "Bilal T.",
      treatment: "Ceramic Braces",
      image: "https://plus.unsplash.com/premium_photo-1681997203595-e45e06abe034?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    }
  ];

  const stats = [
    {
      number: "500+",
      label: "Successful Cases",
      icon: "M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"
    },
    {
      number: "15+",
      label: "Years Experience",
      icon: "M12 1L9 9L1 9L7 14L5 22L12 18L19 22L17 14L23 9L15 9L12 1Z"
    },
    {
      number: "98%",
      label: "Success Rate",
      icon: "M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
    },
    {
      number: "24/7",
      label: "Emergency Care",
      icon: "M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V8H19V19M7 10H12V15H7"
    }
  ];

  const openModal = (beforeImage, afterVideo, title) => {
    setSelectedMedia({ beforeImage, afterVideo, title });
  };

  const closeModal = () => {
    setSelectedMedia(null);
  };

  return (
    <section className="our-work-section" id="our-work">
      <div className="work-container">
        {/* Header */}
        <div className="work-header">
          <div className="work-badge">
            <svg className="badge-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
            </svg>
            <span>Real Patient Transformations</span>
          </div>
          
          <h2 className="work-title">
            Amazing Smile 
            <span className="title-highlight"> Transformations</span>
          </h2>
          
          <p className="work-description">
            See real patients who have transformed their malaligned teeth with our expert orthodontic care. 
            Watch their journey from consultation to beautiful, confident smiles.
          </p>
        </div>

        {/* Stats Section */}
        <div className="stats-section">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d={stat.icon}/>
                </svg>
              </div>
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Patient Cases */}
        <div className="patient-cases">
          {patientCases.map((patient, index) => (
            <div key={patient.id} className="patient-case">
              <div className="case-header">
                <div className="patient-info">
                  <h3 className="case-title">{patient.title}</h3>
                  <div className="patient-details">
                    <span className="patient-name">Patient: {patient.patientName}</span>
                    <span className="patient-age">Age: {patient.age}</span>
                  </div>
                </div>
              </div>

              <div className="media-comparison">
                {/* Before Image */}
                <div className="media-wrapper before-wrapper">
                  <div className="media-container">
                    <img 
                      src={patient.beforeImage} 
                      alt={`Before treatment - ${patient.patientName}`}
                      className="before-image"
                      onClick={() => openModal(patient.beforeImage, patient.afterVideo, patient.title)}
                    />
                    <div className="media-label before-label">
                      <svg className="label-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M9 12L11 14L15 10M21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12Z"/>
                      </svg>
                      Before Treatment
                    </div>
                    <div className="media-overlay">
                      <svg className="expand-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"/>
                      </svg>
                    </div>
                  </div>
                </div>

                {/* VS Divider */}
                <div className="vs-divider">
                  <div className="vs-circle">
                    <span>VS</span>
                  </div>
                  <div className="vs-line"></div>
                </div>

                {/* After Video */}
                <div className="media-wrapper after-wrapper">
                  <div className="media-container">
                    <video 
                      className="after-video"
                      controls
                      poster={patient.beforeImage}
                      onClick={() => openModal(patient.beforeImage, patient.afterVideo, patient.title)}
                    >
                      <source src={patient.afterVideo} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    <div className="media-label after-label">
                      <svg className="label-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M8,5.14V19.14L19,12.14L8,5.14Z"/>
                      </svg>
                      After Treatment Video
                    </div>
                    <div className="play-overlay">
                      <svg className="play-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M8,5.14V19.14L19,12.14L8,5.14Z"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <div className="case-info">
                <p className="case-description">{patient.description}</p>
                
                <div className="treatment-details">
                  <div className="detail-item">
                    <svg className="detail-icon" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
                    </svg>
                    <span>Treatment: {patient.treatment}</span>
                  </div>
                  <div className="detail-item">
                    <svg className="detail-icon" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2M15.5 8L12 10.5 8.5 8 7 9.5L10.5 12 7 14.5 8.5 16 12 13.5 15.5 16 17 14.5 13.5 12 17 9.5 15.5 8Z"/>
                    </svg>
                    <span>Duration: {patient.duration}</span>
                  </div>
                </div>

                <div className="testimonial">
                  <svg className="quote-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14,17H17L19,13V7H13V13H16M6,17H9L11,13V7H5V13H8L6,17Z"/>
                  </svg>
                  <p className="testimonial-text">"{patient.testimonial}"</p>
                  <span className="testimonial-author">- {patient.patientName}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Successful Patients Gallery */}
        <div className="patients-gallery">
          <div className="gallery-header">
            <h3 className="gallery-title">More Success Stories</h3>
            <p className="gallery-subtitle">
              Join our community of satisfied patients who have achieved their perfect smiles
            </p>
          </div>
          
          <div className="gallery-grid">
            {successfulPatients.map((patient) => (
              <div key={patient.id} className="gallery-item">
                <div className="gallery-image-container">
                  <img 
                    src={patient.image} 
                    alt={`${patient.name} - ${patient.treatment} treatment result`}
                    className="gallery-image"
                  />
                  <div className="gallery-overlay">
                    <div className="gallery-info">
                      <h4 className="gallery-patient-name">{patient.name}</h4>
                      <p className="gallery-treatment">{patient.treatment}</p>
                    </div>
                    <div className="gallery-success-badge">
                      <svg className="success-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="gallery-cta">
            <p className="gallery-cta-text">
              See yourself here next! Schedule your consultation today.
            </p>
            <a href="#appointment" className="gallery-cta-button">
              <svg className="btn-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V8H19V19M7 10H12V15H7"/>
              </svg>
              Start Your Journey
            </a>
          </div>
        </div>

        {/* CTA Section */}
        <div className="work-cta">
          <h3 className="cta-title">Ready for Your Own Transformation?</h3>
          <p className="cta-description">
            Join hundreds of satisfied patients who have transformed their smiles with our expert orthodontic care.
          </p>
          <div className="cta-buttons">
            <a href="#appointment" className="cta-primary">
              <svg className="btn-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V8H19V19M7 10H12V15H7"/>
              </svg>
              Schedule Free Consultation
            </a>
            <a href="#contact" className="cta-secondary">
              <svg className="btn-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"/>
              </svg>
              Call Now
            </a>
          </div>
        </div>

        {/* Background Elements */}
        <div className="work-bg-elements">
          <div className="bg-circle circle-1"></div>
          <div className="bg-circle circle-2"></div>
          <div className="bg-circle circle-3"></div>
        </div>
      </div>

      {/* Modal for Media Zoom */}
      {selectedMedia && (
        <div className="media-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"/>
              </svg>
            </button>
            <h3 className="modal-title">{selectedMedia.title}</h3>
            <div className="modal-media">
              <div className="modal-media-wrapper">
                <img src={selectedMedia.beforeImage} alt="Before" />
                <span className="modal-label">Before Treatment</span>
              </div>
              <div className="modal-vs">VS</div>
              <div className="modal-media-wrapper">
                <video controls autoPlay>
                  <source src={selectedMedia.afterVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <span className="modal-label">After Treatment</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default OurWork; 